import React, { FC } from 'react';
import { Control, Controller, FieldErrors, useWatch } from 'react-hook-form';

import { CurrencyInput, formatCurrencyValue } from '@eika/currency-input';

import { useTranslation } from '../../translations';
import { GjeldFormData } from './gjeld';

interface Props {
    index: number;
    control: Control<GjeldFormData>;
    errors: FieldErrors<GjeldFormData>;
}

const Fellesgjeld: FC<Props> = ({ index, control, errors }) => {
    const { gjeld, validationMessage } = useTranslation();
    const value = useWatch({ name: 'gjeld', control });

    return (
        <div className="form-box-seagreen margin-bottom-small">
            <span className="title margin-bottom-smaller">{value?.[index]?.laangiver}</span>
            <span className={`row ${value?.[index]?.skalViseFellesutgifter ? 'margin-bottom-medium' : ''}`}>
                <span>Type: Andel fellesgjeld</span>
                <span>{`${gjeld.infoRestgjeld}: ${formatCurrencyValue(Number(value?.[index]?.restgjeld))} kr`}</span>
            </span>
            {value?.[index]?.skalViseFellesutgifter && (
                <Controller
                    control={control}
                    name={`gjeld.${index}.maanedligeFellesutgifter` as const}
                    rules={{
                        required: `${validationMessage.requiredValue}`,
                    }}
                    render={({ field: { onChange, value } }) => (
                        <CurrencyInput
                            name={`gjeld.${index}.maanedligeFellesutgifter` as const}
                            placeholder=""
                            className="max-width-200"
                            type="tel"
                            label={gjeld.labelMaanedligeFellesutgifter}
                            value={value == null ? undefined : value}
                            onValueChange={(v) => onChange(v.value)}
                            error={errors.gjeld?.[index]?.maanedligeFellesutgifter?.message}
                        />
                    )}
                />
            )}
        </div>
    );
};

export default Fellesgjeld;
